import { Suspense, useEffect } from 'react';
import ReactGA from 'react-ga';
import toast from 'react-hot-toast';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import './highcharts.css';
import ActivitiesChart from './pages/ActivitiesChart';
import ActivityDayChart from './pages/ActivityDayChart';
import Appbar from './pages/Appbar';
import Calendar from './pages/Calendar';
import Fitness from './pages/Fitness';
import RunningChart from './pages/RunningChart';
import Table from './pages/Table';
import TriathlonChart from './pages/TriathlonChart';
import WeekScatterChart from './pages/WeekScatterChart';
import Zones from './pages/Zones';
import { authState } from './recoil';
import styles from './style.module.css';

import 'simplebar-react/dist/simplebar.min.css';
import { useGetAccessToken } from './hooks/useGetAccessToken';
import {
  ACTIVITY_YEAR_PATH,
  CALENDAR_PATH,
  FITNESS_PATH,
  RUNNING_DAY_PATH,
  RUNNING_PATH,
  TABLE_PATH,
  TRIATHLON_PATH,
  WEEK_PATH,
  ZONES_PATH,
} from './utils/routes';

// React.lazy() performs lazy loading through code splitting, with dynamic import()
// const Zones = lazy(() => import('./pages/Zones'));

const Home = () => {
  const [authorization_code] = useRecoilState(authState);
  const { access_token, isLoading } = useGetAccessToken();

  useEffect(() => {
    ReactGA.pageview(window.location.pathname);
  }, []);

  useEffect(() => {
    if (!authorization_code) {
      toast.error('no authorization_code');
    }
  }, [authorization_code]);

  useEffect(() => {
    if (!isLoading && !access_token) {
      toast.error('no access_token');
    }
  }, [access_token]);

  return (
    <>
      <Appbar />
      <div className={styles.container}>
        {/* affiche un fallback pendant le chargement du JS du composant lazy loadé et wrappé dans un <Suspense /> */}
        <Suspense fallback={<h1>Loading...</h1>}>
          <Routes>
            <Route path="/*" element={<Navigate to={TRIATHLON_PATH} />} />
            <Route path={TRIATHLON_PATH} element={<TriathlonChart />} />
            <Route path={ACTIVITY_YEAR_PATH} element={<ActivitiesChart />} />
            <Route path={RUNNING_PATH} element={<RunningChart />} />
            <Route path={RUNNING_DAY_PATH} element={<ActivityDayChart />} />
            <Route path={WEEK_PATH} element={<WeekScatterChart />} />
            <Route path={CALENDAR_PATH} element={<Calendar />} />
            <Route path={TABLE_PATH} element={<Table />} />
            <Route path={ZONES_PATH} element={<Zones />} />
            <Route path={FITNESS_PATH} element={<Fitness />} />
          </Routes>
        </Suspense>
      </div>
    </>
  );
};

export default Home;
